import { useEffect, useState } from 'react';
import { containsBulkDeals, getSelectedItem, globals, isFreeGift, shouldShowCheckoutButton } from 'common-ui';
import type { CartProps, LineItem } from 'tsconfig/types';

export function useMiniCartLogic(
  cartItems: CartProps | undefined,
  selectedItemCode: string,
  currentMiniCartItemCode: string,
  setCurrentMiniCartItemCode: (code: string) => void,
): {
  selectedItem: LineItem[];
  showCheckoutButton: boolean;
  isFreeGiftLineItem: boolean;
  isGreatPick: boolean;
} {
  const [selectedItem, setSelectedItem] = useState<LineItem[]>([]);
  const [showCheckoutButton, setShowCheckoutButton] = useState(false);
  const [isFreeGiftLineItem, setIsFreeGiftLineItem] = useState(false);
  const [isGreatPick, setIsGreatPick] = useState(false);

  useEffect(() => {
    if (!cartItems) {
      setSelectedItem([]);
      setShowCheckoutButton(false);
      setIsFreeGiftLineItem(false);
      setIsGreatPick(false);
      return;
    }

    const item = getSelectedItem(cartItems, selectedItemCode);
    setSelectedItem(item);

    if (currentMiniCartItemCode !== '' && selectedItemCode !== currentMiniCartItemCode) {
      setIsGreatPick(true);
    }
    setCurrentMiniCartItemCode(selectedItemCode);

    setShowCheckoutButton(shouldShowCheckoutButton(cartItems));

    const hasBulkDeals = containsBulkDeals(cartItems);
    const freeGift = isFreeGift(cartItems, hasBulkDeals, globals.useNewCartAPI);
    setIsFreeGiftLineItem(freeGift);
  }, [cartItems, selectedItemCode]);

  return { selectedItem, showCheckoutButton, isFreeGiftLineItem, isGreatPick };
}
